import React, {useState, useEffect} from 'react'
import request from '../utils/request'

const HotArticleList = ({articleId}) => {
  const [hotArticleList, setHotArticleList] = useState([])

  useEffect(() => {
    if (!articleId) {
      return
    }
    // 获取热门文章
    const getHotArticleListRes = async () => {
      const data = await request.post(`/unauthorize/articleDetail/randomList`)
      if (data.resultCode === '0') {
        const {randomList} = data.result
        setHotArticleList(randomList)
      }
    }

    getHotArticleListRes()
  }, [articleId])

  const goNextPage = (e, nextArticleId) => {
    e.stopPropagation()
    const url = window.location.href

    const lastIndex = url.lastIndexOf('/')
    
    const preUrl = url.slice(0, lastIndex)

    const nextUrl = `${preUrl}/${nextArticleId}`

    window.location.href = nextUrl
  }

  return (
    <section className="warparea1">
      <div className="pop-info">
        <i className="info-ico mr5"></i>
        热门资讯
      </div>
      <ul className="pop-info-list ml25 mr25">
        {
          hotArticleList.map(item => (
            <li key={item.ID} onClick={(e) => goNextPage(e, item.ID)}>
              <div className="pop-info-list-txt">
                <div className="fS14 txt">
                  <span>{item.title}</span>
                </div>
                <div className="fS12 cyellow bq">
                  {
                    item.articleTagsList.map(inner => <span key={inner.aId}>{inner.name}</span>)
                  }
                </div>
              </div>
              <div className="pop-info-list-pic">
                <img
                  width="90px"
                  src={item.articleImg}
                  title=""
                  alt=""
                />
              </div>
            </li>
          ))
        }
      </ul>
    </section>
  )
}

// React.memo 第二个参数 如果是false是 是渲染组件 否则不渲染组件  与shouldComponentUpdate 相反
export default React.memo(HotArticleList, (preProps, nextProps) => preProps.articleId === nextProps.articleId)
